var _path, _path2, _circle, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666504 8.43945C0.666504 6.7826 2.00965 5.43945 3.6665 5.43945H20.1665C20.9949 5.43945 21.6665 6.11103 21.6665 6.93945C21.6665 7.76788 22.3381 8.43945 23.1665 8.43945H35.6665C37.3234 8.43945 38.6665 9.7826 38.6665 11.4395V34.4395C38.6665 36.0963 37.3234 37.4395 35.6665 37.4395H3.6665C2.00965 37.4395 0.666504 36.0963 0.666504 34.4395V8.43945Z",
    fill: "#E89A1D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.26234 15.9655C4.4952 14.5101 5.75077 13.4395 7.22466 13.4395H39.1483C40.9943 13.4395 42.4023 15.0907 42.1107 16.9134L39.0707 35.9134C38.8378 37.3688 37.5822 38.4395 36.1083 38.4395H4.18466C2.33873 38.4395 0.930699 36.7882 1.22234 34.9655L4.26234 15.9655Z",
    fill: "#F4AE18"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.4998,
    cy: 36.2728,
    r: 9.83333,
    fill: "#0B64FF",
    stroke: "#F9F9F9",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5039 35.6156L38.1187 34.327L38.1278 38.836C38.1278 39.0774 37.9179 39.2728 37.6584 39.2728C37.3999 39.2728 37.1891 39.0774 37.1891 38.836L37.1799 34.3577L35.8286 35.6156C35.6452 35.7858 35.3482 35.7858 35.1648 35.6156C34.9815 35.445 34.9815 35.1681 35.1648 34.9975L37.0965 33.2001C37.2248 33.0418 37.4292 32.9395 37.6584 32.9395C37.8372 32.9395 37.9995 33.0009 38.1232 33.1024C38.1416 33.1152 38.159 33.1293 38.1755 33.1446L40.1676 34.9975C40.351 35.1681 40.351 35.445 40.1676 35.6156C39.9843 35.7858 39.6873 35.7858 39.5039 35.6156Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6665 4.5C9.6665 2.29086 11.4574 0.5 13.6665 0.5H21.1665H27.1465L32.6665 6.02V10.62V13.38H9.6665V4.5Z",
    fill: "#E1EBF1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1465 5.02V0.5L32.6665 6.02H28.1465C27.5942 6.02 27.1465 5.57229 27.1465 5.02Z",
    fill: "#BBCAE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileDrop);
export default __webpack_public_path__ + "static/media/fileDrop.f8da4777464ecaa6115e35c2dce2bdf8.svg";
export { ForwardRef as ReactComponent };